// socket setup
import socketIOClient from "socket.io-client";
import Manager from "socket.io-client/lib/manager";
import Config from '../react/features/customise/config';
const { socket_endpoint } = Config;
//const socket = socketIOClient(socket_endpoint);

let socket;

export const cloneSocket = () => {
    if(!socket) {
        socket = socketIOClient(socket_endpoint);
        // TEST PURPOSE:
        // let manager = new Manager(socket_endpoint);
        // socket = manager.socket('/rta'); 
    }

    socket.on("connect", () => {
        console.log("------------------connected", socket.id);
        localStorage.setItem('socketId', socket.id);
        window.socketSessionId = socket.id;
    });
    return socket;
} 

export const socketEmit = (event, message) => {
    cloneSocket();
    socket.emit(event, message);
}

export const socketOn = (event, message) => {
    cloneSocket();
    socket.on(event, message);
}

